import { render, staticRenderFns } from "./ShipCategoryLogistics.vue?vue&type=template&id=2366cd36&scoped=true&"
import script from "./ShipCategoryLogistics.vue?vue&type=script&lang=js&"
export * from "./ShipCategoryLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366cd36",
  null
  
)

export default component.exports